import copy from 'copy-to-clipboard';

const copyToClipboard = (text: string, setCopyButtonText: (text: string) => void) => {
	if (text) {
		const plainText = text.replace(/(?:__|[*#])|\[(.*?)\]\(.*?\)/g, '$1');
		copy(plainText);
		setCopyButtonText('Copied');
		setTimeout(() => {
			setCopyButtonText('Copy');
		}, 1000);
	}
};

export default copyToClipboard;
